<template>
    <!-- :color still drives the slider and the active-tab color in the normal case;
         the scoped CSS var only forces the text to win over Vuetify's preset-background white rule. -->
    <v-tabs :key="renderKey" :centered="centered" :grow="grow" :vertical="vertical" :showArrows="arrows" :right="right" :background-color="backgroundColor" :color="color" :class="{'zoezi-tabbar--bold-selected': boldSelected, 'zoezi-tabbar--color-selected': !!resolvedSelectedColor, 'zoezi-tabbar--size-selected': !!selectedFontSize}" :style="tabBarStyle">
        <draggable v-model="tabscopy" :disabled="!$root.edit || tabs.length == 1" @change="save" tag="ContentsContainer" v-if="$root.edit && !centered">
            <v-tab v-for="tab in tabs" :key="tab.name"><span v-zoezi-editable="{setProp: (value) => tab.name = value, html: false, multiline: false}">{{tab.name}}</span></v-tab>
        </draggable>

        <template v-else>
            <v-tab v-for="tab in tabs" :key="tab.name">{{tab.name}}</v-tab>
        </template>

        <v-tab v-if="$root.edit">
            <v-btn
                fab
                small
                color="zoezi-edit-color"
                @click="add"
                elevation="3"
            >
                <v-icon>mdi-plus</v-icon>
            </v-btn>
        </v-tab>

        <v-tab-item v-for="tab in tabs" :key="tab.id">
            <component-wrapper
                :config="tab"
                :array="tabs"
                can-remove
            />
        </v-tab-item>

    </v-tabs>
</template>

<script>
import components from '../component.js'
import Draggable from 'vuedraggable';
import {omitBy} from 'lodash';

export default {
    name: 'zoezi-tabbar',

    zoezi: {
        title: 'Tab row',
        icon: 'mdi-tab'
    },

    components: {
        Draggable
    },

    props: {
        tabs: {
            title: 'Tabs',
            type: Array,
            default: () => [components.makeEmptyConfig({name: window.$translate('New tab')})],
            fulltype: 'namelist',
            typeinfo: {
                getNewName(tabs) {
                    const newTabName = window.$translate('New tab');

                    let numNew = tabs.filter(x => x.name.startsWith(newTabName)).length;
                    let suffix = numNew == 0 ? '' : (' ' +   (numNew+1));
                    return newTabName + suffix;
                }
            }
        },
        arrows: {
            title: 'Show arrows',
            type: Boolean,
            default: false
        },
        centered: {
            title: 'Centered tabs',
            type: Boolean,
            default: false
        },
        grow: {
            title: 'Let the tabs fill the entire space',
            type: Boolean,
            default: false
        },
        vertical: {
            title: 'Vertical tabs',
            type: Boolean,
            default: false
        },
        right: {
            title: 'Align tabs to the right',
            type: Boolean,
            default: false
        },
        boldSelected: {
            title: 'Bold text on selected tab',
            type: Boolean,
            default: false
        },
        selectedFontSize: {
            title: 'Font size of selected tab (px)',
            type: Number,
            fulltype: 'number-slider',
            typeinfo: {min: 12, max: 32, step: 1}
        },
        backgroundColor: {
            title: 'Background color for tab row',
            type: String,
            fulltype: 'color'
        },
        color: {
            title: 'Color for selected tab',
            type: String,
            fulltype: 'color'
        }
    },
    computed: {
        resolvedSelectedColor() {
            return this.$root.colorToHex(this.color);
        },
        tabBarStyle() {
            const style = {};
            if (this.selectedFontSize) style['--zoezi-tab-selected-size'] = this.selectedFontSize + 'px';
            if (this.resolvedSelectedColor) style['--zoezi-tab-selected-color'] = this.resolvedSelectedColor;
            return style;
        }
    },
    data: () => ({
        renderKey: 0,
        tabscopy: null
    }),
    methods: {
        save() {
            const props = omitBy(this.$props, v => v === undefined)
            props.tabs = this.tabscopy;
            this.$emit('save', props);
            ++this.renderKey;
        },
        add() {
            const newTabName = window.$translate('New tab');

            let numNew = this.tabs.filter(x => x.name.startsWith(newTabName)).length;
            let suffix = numNew == 0 ? '' : (' ' + (numNew+1));
            this.tabs.splice(this.tabs.length, 0, components.makeEmptyConfig({name: newTabName + suffix}));
            this.save();
        }
    },
    created() {
        this.tabscopy = this.tabs;
    }
}
</script>

<style scoped>
/* !important is required: Vuetify paints preset-background tabs white, which beats the inherited color. */
.v-tabs.zoezi-tabbar--color-selected >>> .v-tab--active {
    color: var(--zoezi-tab-selected-color) !important;
}
.v-tabs.zoezi-tabbar--bold-selected >>> .v-tab--active {
    font-weight: 700;
}
.v-tabs.zoezi-tabbar--size-selected >>> .v-tab--active {
    font-size: var(--zoezi-tab-selected-size);
}
</style>
